export const REVIEW_SUMMARY = {
  rating: 5.0,
  count: 17,
  placeUrl: "https://maps.google.com/?cid=13821789688590389635",
  writeReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJtVHTPeyVl0cRg1GWpH3c0L8",
};

export type Review = {
  name: string;
  when: string;
  text: string;
  /** Optional override for avatar background color (Tailwind class). */
  avatarColor?: string;
};

export const REVIEWS: Review[] = [
  {
    name: "Mareike Herb-Schmuchal",
    when: "vor einem Jahr",
    text: "Beratung, Planung, Durchführung: alles super und problemlos. Würde ich jederzeit wieder so machen.",
    avatarColor: "bg-teal-500",
  },
  {
    name: "Martin",
    when: "vor 4 Monaten",
    text: "Zu H. Ehmer bin ich per Empfehlung gekommen. Seine Beratung und die wichtigen Detailinformationen (kein „Gelabere\" sondern praktische Details) gaben mir ein gutes Gefühl. Anfänglich wollte ich nichts von einer PV-Anlage wissen, bin jetzt allerdings begeistert, wenn ich sehe was vom Dach kommt und wie ich meine Bedarfe dadurch steuern kann!",
    avatarColor: "bg-amber-500",
  },
  {
    name: "Christophe Bauduin",
    when: "vor 3 Monaten",
    text: "Wir sind sehr zufrieden mit der Arbeit und der Kommunikation mit Herrn Ehmer. Wir haben und werden das Unternehmen mit gutem Gewissen weiterempfehlen. Der Einbau und die Anmeldung haben schnell und unkompliziert geklappt.",
    avatarColor: "bg-orange-500",
  },
  {
    name: "Thomas Leidner",
    when: "vor 9 Monaten",
    text: "Wer die Planung, Umsetzung sowie die weitere Betreuung seiner PV-Anlage in kompetente Hände legen möchte, ist bei Herrn Ehmer in den allerbesten Händen. Professionell hat er uns zu unserer Wunschanlage verholfen und ist auch nach der Inbetriebnahme immer ansprechbar. Sehr gerne möchten wir daher die Firma WM Erneuerbare Energien an alle Interessierten weiterempfehlen.",
    avatarColor: "bg-stone-700",
  },
  {
    name: "Matthias Hallaschek",
    when: "vor einem Jahr",
    text: "Wir haben sehr gute Erfahrungen gemacht. Herr Ehmer war sehr offen für unsere Wünsche und lösungsorientiert. Wir haben nun eine sehr schöne und tadellos funktionierende PV Anlage.",
    avatarColor: "bg-orange-600",
  },
];
